export enum BrandMode {
  Short = 'short',
  Medium = 'medium',
  Long = 'long'
}

export enum DeckTexture {
  Silk = 'silk',
  Brick = 'brick',
  Rock = 'rock',
  Sand = 'sand',
  Crack = 'crack',
  Carbon = 'carbon'
}

export enum ICON_WEIGHT {
  thin = 'thin',
  light = 'light',
  regular = 'regular',
  bold = 'bold',
  fill = 'fill',
  duotone = 'duotone'
}

export enum SIZE {
  xs = 'xs',
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  xl = 'xl',
  xxl = 'xxl'
}

export enum VARIANT {
  action = 'action',
  primary = 'primary',
  secondary = 'secondary',
  tertiary = 'tertiary',
  info = 'info',
  success = 'success',
  warning = 'warning',
  danger = 'danger',
  link = 'link',
  light = 'light',
  dark = 'dark',
  outline_action = 'outline-action',
  outline_primary = 'outline-primary',
  outline_secondary = 'outline-secondary',
  outline_tertiary = 'outline-tertiary',
  outline_info = 'outline-info',
  outline_success = 'outline-success',
  outline_warning = 'outline-warning',
  outline_danger = 'outline-danger',
  outline_light = 'outline-light',
  outline_dark = 'outline-dark',
}

export enum PLACEMENTS {
  TOP = 'top',
  TOPLEFT = 'topleft',
  TOPRIGHT = 'topright',
  RIGHT = 'right',
  RIGHTTOP = 'righttop',
  RIGHTBOTTOM = 'rightbottom',
  BOTTOM = 'bottom',
  BOTTOMLEFT = 'bottomleft',
  BOTTOMRIGHT = 'bottomright',
  LEFT = 'left',
  LEFTTOP = 'lefttop',
  LEFTBOTTOM = 'leftbottom'
}

export enum SlideUpDownState {
  pre = 'pre',
  active = 'active',
  post = 'post'
}

export enum SharingPlatform {
  email = 'email',
  facebook = 'facebook',
  linkedin = 'linkedin',
  bluesky = 'bluesky'
}

export enum DonatePeriod {
  onetime = 'onetime',
  monthly = 'monthly',
  yearly = 'yearly'
}

export enum DonationCategory {
  conversation = 'conversation',
  rules = 'rules',
  world = 'world'
}

export enum AdvancedLinkTab {
  raw = 'raw',
  rich = 'rich',
  markdown = 'markdown',
  html = 'html'
}

export enum LegendCategory {
  id = 'id',
  color = 'color',
  path = 'path',
  label = 'label'
}
